import React, { useState } from 'react';
import TranslationModal from './TranslationModal';
import axios from 'axios';
import SERVER from '../../hooks/useServer';
import '../../styles/components/Admin/TranslationButton.scss';

const TranslationButton = ({ data, type, onTranslationSaved }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasTranslation, setHasTranslation] = useState(false);

  // Check if item has English translation
  React.useEffect(() => {
    const checkTranslation = () => {
      if (type === 'product') {
        return !!(data.title_en || data.description_en);
      } else {
        return !!data.title_en;
      }
    };
    setHasTranslation(checkTranslation());
  }, [data, type]);

  const validateRequiredFields = () => {
    if (!data.title || data.title.trim() === '') {
      return 'Le titre en français est requis';
    }
    
    if (type === 'product' && (!data.description || data.description.trim() === '')) {
      return 'La description en français est requise';
    }
    
    return null;
  };

  const handleOpenModal = () => {
    const validationError = validateRequiredFields();
    if (validationError) {
      alert(validationError);
      return;
    }
    setIsModalOpen(true);
  };

  const handleSaveTranslation = async (translations) => {
    try {
      let endpoint;
      switch (type) {
        case 'product':
          endpoint = `/admin/translations/products/${data.id}`;
          break;
        case 'category':
          endpoint = `/admin/translations/categories/${data.id}`;
          break;
        case 'subcategory':
          endpoint = `/admin/translations/subcategories/${data.id}`;
          break;
        default:
          throw new Error('Invalid type');
      }

      const response = await axios.put(`${SERVER}${endpoint}`, translations);
      
      if (response.data.success) {
        setHasTranslation(true);
        if (onTranslationSaved) {
          onTranslationSaved(response.data);
        }
        alert('Traduction sauvegardée avec succès!');
      }
    } catch (error) {
      console.error('Error saving translation:', error);
      throw error;
    }
  };

  return (
    <div className="translation-button-container">
      <button 
        className={`translation-btn ${hasTranslation ? 'has-translation' : 'no-translation'}`}
        onClick={handleOpenModal}
        title={hasTranslation ? 'Modifier la traduction' : '⚠️ Vérifiez que les champs en langue principale sont bien remplis'}
      >
        {hasTranslation ? '🌐 Modifier traduction' : '🌐 Ajouter traduction'}
      </button>
      

      <TranslationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={data}
        type={type}
        onSave={handleSaveTranslation}
      />
    </div>
  );
};

export default TranslationButton;
